import { createFileRoute } from "@tanstack/react-router";

import { HomeNav } from "@/components/home-nav";
import { ParallaxSlab } from "@/components/parallax-slab";
import { SiteFooter } from "@/components/site-footer";
import { mainProjects } from "@/data/journeys";
import { useI18n } from "@/lib/i18n";

export const Route = createFileRoute("/main-projects")({
  head: () => ({
    meta: [
      { property: "og:url", content: "https://www.luizajesusdoprado.com/main-projects" },
      { title: "Main Projects | Luiza Jesus do Prado" },
      {
        name: "description",
        content:
          "Selected main projects by Luiza Jesus do Prado — photography, performance, sound, sculpture and research.",
      },
      { property: "og:title", content: "Main Projects | Luiza Jesus do Prado" },
      {
        property: "og:description",
        content: "Selected main projects across photography, performance, sound and research.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: MainProjectsPage,
});

function MainProjectsPage() {
  const { lang } = useI18n();
  const main = mainProjects().filter((p) => p.cover);

  return (
    <div className="min-h-screen bg-ink text-bone">
      <HomeNav />

      <main id="main-content" className="pt-28 md:pt-32">
        <header className="flex flex-wrap items-baseline justify-between gap-4 border-b border-bone/15 px-6 py-6 md:px-12">
          <h1 className="font-mono text-[10px] uppercase tracking-[0.4em] text-bone/70">
            {lang === "en"
              ? "Main projects"
              : lang === "es"
                ? "Proyectos principales"
                : "Principais projetos"}
          </h1>
          <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-bone/65">
            {String(main.length).padStart(2, "0")}
          </span>
        </header>

        <div>
          {main.map((p, i) => (
            <ParallaxSlab key={p.slug} project={p} index={i} />
          ))}
        </div>
      </main>

      <SiteFooter />
    </div>
  );
}
